'use client';

import useDictionary from '@modules/Dictionary/useDictionary';

export default function DictionaryText({ translationKey, fallback }) {
  const { dictionary } = useDictionary();

  if (!dictionary || !translationKey) return <>{fallback}</>;

  const keys = translationKey.split('.');
  let value = dictionary;
  for (const key of keys) {
    if (value[key] === undefined) {
      return <>{fallback}</>;
    }
    value = value[key];
  }

  return <>{value || fallback}</>;
}
